import { Route } from "@angular/router";
import { initialDataResolver } from "app/app.resolvers";
import { AuthGuard } from "app/core/auth/guards/auth.guard";
import { NoAuthGuard } from "app/core/auth/guards/noAuth.guard";
import { LayoutComponent } from "app/layout/layout.component";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  { path: "", pathMatch: "full", redirectTo: "dashboards" },
  { path: "signed-in-redirect", pathMatch: "full", redirectTo: "dashboards" },

  // Auth routes for guests
  {
    path: "",
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "confirmation-required",
        loadChildren: () => import("app/modules/auth/confirmation-required/confirmation-required.routes"),
      },
      {
        path: "forgot-password",
        loadChildren: () => import("app/modules/auth/forgot-password/forgot-password.routes"),
      },
      { path: "reset-password", loadChildren: () => import("app/modules/auth/reset-password/reset-password.routes") },
      { path: "sign-in", loadChildren: () => import("app/modules/auth/sign-in/sign-in.routes") },
      { path: "sign-up", loadChildren: () => import("app/modules/auth/sign-up/sign-up.routes") },
    ],
  },

  // Auth routes for authenticated users
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      { path: "sign-out", loadChildren: () => import("app/modules/auth/sign-out/sign-out.routes") },
      { path: "unlock-session", loadChildren: () => import("app/modules/auth/unlock-session/unlock-session.routes") },
    ],
  },

  // Landing routes
  //   {
  //     path: "",
  //     component: LayoutComponent,
  //     data: {
  //       layout: "empty",
  //     },
  //     children: [
  //       {
  //         path: "home",
  //         loadChildren: () => import("app/modules/landing/home/home.routes"),
  //       },
  //     ],
  //   },

  // Admin routes
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "dashboards",
        loadChildren: () => import("app/modules/dashboard/dashboard.routes"),
      },
      {
        path: "registers",
        loadChildren: () => import("app/modules/registers/registers.routes"),
      },
      {
        path: "estoque",
        loadChildren: () => import("app/modules/estoque/estoque.routes"),
      },
      {
        path: "aluguel",
        loadChildren: () => import("app/modules/aluguel/aluguel.routes"),
      },
      {
        path: "contabil",
        loadChildren: () => import("app/modules/contabil/contabil.routes"),
      },
    ],
  },
];
